@if (!router.url.includes('login')) {
  <app-header></app-header>
}
<div>
  <div class="container-web"
    [ngClass]="{'is-login-page': router.url.includes('login')}">
    <router-outlet />
  </div>
</div>